import hash from 'hash-it';
import { parseEntityRef } from '@backstage/catalog-model';
import {
  InstanceHashKey,
  CategoryHashKey,
  HashingApi,
} from '@mercedes-benz/tech-insights-common';

export class Hashing implements HashingApi {
  /**
   * Creates a unique hash for the workflow instance based on its workflow slug, owner reference, and context.
   * This hash is used to identify the instance across runs.
   * @param key - The key containing workflow slug, owner reference, and optional context to create a hash for.
   * @returns A number representing the unique hash for the instance.
   */
  createInstanceHash(key: InstanceHashKey): number {
    if (!this.validRef(key.ownerRef)) {
      throw new Error(`Invalid owner reference: ${key.ownerRef}`);
    }

    return hash({
      workflowSlug: key.workflowSlug,
      ownerRef: key.ownerRef,
      context: key.context,
    });
  }

  /**
   * Creates a hash for the workflow instance based on its category.
   * This is used to group instances by category for aggregation purposes.
   * @param key - The key containing workflow slug, owner reference, and category slug to create a category hash for.
   * @returns A number representing the category hash.
   */
  createCategoryHash(key: CategoryHashKey): number {
    if (!this.validRef(key.ownerRef)) {
      throw new Error(`Invalid owner reference: ${key.ownerRef}`);
    }

    return hash({
      workflowSlug: key.workflowSlug,
      ownerRef: key.ownerRef,
      category: key.categorySlug,
    });
  }

  private validRef(entityRef: string): boolean {
    try {
      parseEntityRef(entityRef);
      return true;
    } catch (e) {
      // Do nothing if parsing fails
    }
    return false;
  }
}
